(function () {
  'use strict';

  // Moving all constants at a common place
  angular.module('tf.retailer.Util')
      .constant('BRAND_URL', '/brands/')
      .constant('STYLE_URL', '/report/styles/');


})();